import { createContext, useCallback, useContext, useMemo, useState } from "react";

import DuplicateCourseModal from "./Facilitators/DuplicateCourseModal";

import { hasRole } from "../services/wp.user.service";
import { useAuth } from "../services/wp.auth.service";

const FacilitatorGlobalContext = createContext(null);

// eslint-disable-next-line react/prop-types
export const FacilitatorGlobalProvider = ({ children }) => {
	const { user } = useAuth();

	if (!hasRole(["facilitator", "staff", "administrator"], user)) {
		return children;
	}

	const [eventToDuplicate, setEventToDuplicate] = useState(null);
	const cancelEventDupe = useCallback(() => setEventToDuplicate(() => null), [setEventToDuplicate]);

	const providerReturn = useMemo(() => ({
		duplicateEvent: setEventToDuplicate
	}), []);

	return (
		<FacilitatorGlobalContext.Provider value={providerReturn}>
			{children}
			<DuplicateCourseModal event={eventToDuplicate} onCancel={cancelEventDupe} show={!!eventToDuplicate} />
		</FacilitatorGlobalContext.Provider>
	);
};

export const useFacilitatorGlobal = () => useContext(FacilitatorGlobalContext);
